import './CourseReviewCard.scss';
import icons from '@assets/icons/redesign';

const { Star } = icons;

export default function CourseReviewCard({ title, text }) {
  return (
    <figure className="courseReviewCard">
      <figcaption className="courseReviewCard-title">{title}</figcaption>
      <blockquote className="courseReviewCard-quote">{text}</blockquote>
      <div className="courseReviewCard-stars">
        {[...Array(5)].map((_, idx) => (
          <Star key={idx} className="courseReviewCard-star" />
        ))}
      </div>
    </figure>
  );
}
